/** Configuración de fase de lanzamiento (`app_config.key = launch_phase`). */

export const DEFAULT_LAUNCH_PHASE = {
  phase: 1,
  label: 'L1 beta cerrada',
  message: 'Esta función estará disponible en la siguiente fase del lanzamiento.',
  flags: {
    payments_enabled: false,
    auctions_enabled: false,
    partner_ops_enabled: false,
    guest_marketplace_enabled: false,
    marketplace_partner_logistics_enabled: false,
    /** Pantalla «Acceso por invitación» (PasswordGate). L4 → false en Supabase. */
    invitation_gate_enabled: true,
  },
};

/** Ruta interna `page` → flag en `flags`. */
export const PAGE_TO_LAUNCH_FLAG = {
  subastas: 'auctions_enabled',
  'grooves-checkout': 'payments_enabled',
  'marketplace-checkout': 'payments_enabled',
  'partner-panel': 'partner_ops_enabled',
};

export const LAUNCH_PHASE_BLOCKED_LABELS = {
  auctions_enabled: 'Subastas',
  payments_enabled: 'Pagos',
  partner_ops_enabled: 'Panel Partner',
};

export function parseLaunchPhaseConfig(raw) {
  if (!raw || typeof raw !== 'object') {
    return {
      phase: DEFAULT_LAUNCH_PHASE.phase,
      label: DEFAULT_LAUNCH_PHASE.label,
      message: DEFAULT_LAUNCH_PHASE.message,
      flags: { ...DEFAULT_LAUNCH_PHASE.flags },
    };
  }
  const flagsIn = raw.flags && typeof raw.flags === 'object' ? raw.flags : {};
  return {
    phase: Number(raw.phase) || DEFAULT_LAUNCH_PHASE.phase,
    label: String(raw.label || DEFAULT_LAUNCH_PHASE.label),
    message: String(raw.message || DEFAULT_LAUNCH_PHASE.message),
    flags: {
      ...DEFAULT_LAUNCH_PHASE.flags,
      payments_enabled: !!flagsIn.payments_enabled,
      auctions_enabled: !!flagsIn.auctions_enabled,
      partner_ops_enabled: !!flagsIn.partner_ops_enabled,
      guest_marketplace_enabled: !!flagsIn.guest_marketplace_enabled,
      marketplace_partner_logistics_enabled: !!flagsIn.marketplace_partner_logistics_enabled,
      invitation_gate_enabled:
        flagsIn.invitation_gate_enabled !== undefined
          ? !!flagsIn.invitation_gate_enabled
          : DEFAULT_LAUNCH_PHASE.flags.invitation_gate_enabled,
    },
  };
}

/** L1–L3: pantalla de contraseña de invitación; L4: sitio abierto (si flag no fuerza otra cosa). */
export function isInvitationGateEnabled(cfg) {
  if (!cfg) return DEFAULT_LAUNCH_PHASE.flags.invitation_gate_enabled;
  if (cfg.flags?.invitation_gate_enabled === false) return false;
  if (Number(cfg.phase) >= 4) return false;
  return cfg.flags?.invitation_gate_enabled !== false;
}

export function isLaunchFlagEnabled(cfg, flagKey) {
  if (!cfg || !flagKey) return true;
  return !!cfg.flags?.[flagKey];
}

export function getLaunchBlockForPage(cfg, page) {
  const flagKey = PAGE_TO_LAUNCH_FLAG[page];
  if (!flagKey || isLaunchFlagEnabled(cfg, flagKey)) return null;
  return {
    flagKey,
    sectionLabel: LAUNCH_PHASE_BLOCKED_LABELS[flagKey] || 'Sección',
    message: cfg.message || DEFAULT_LAUNCH_PHASE.message,
    phase: cfg.phase,
    label: cfg.label,
  };
}
